/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Basic serializer to pass CustomUser details to the front end.
 * Extend with any fields your app needs.
 * @export
 * @interface PatchedCustomUser
 */
export interface PatchedCustomUser {
    /**
     * 
     * @type {number}
     * @memberof PatchedCustomUser
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    email?: string;
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @type {string}
     * @memberof PatchedCustomUser
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    readonly avatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    readonly getDisplayName?: string;
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof PatchedCustomUser
     */
    isActive?: boolean;
    /**
     * Designates that this user has all permissions without explicitly assigning them.
     * @type {boolean}
     * @memberof PatchedCustomUser
     */
    isSuperuser?: boolean;
    /**
     * Designates whether the user can log into this admin site.
     * @type {boolean}
     * @memberof PatchedCustomUser
     */
    isStaff?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    readonly hasUsablePassword?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    timezone?: string;
}

/**
 * Check if a given object implements the PatchedCustomUser interface.
 */
export function instanceOfPatchedCustomUser(value: object): value is PatchedCustomUser {
    return true;
}

export function PatchedCustomUserFromJSON(json: any): PatchedCustomUser {
    return PatchedCustomUserFromJSONTyped(json, false);
}

export function PatchedCustomUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedCustomUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'username': json['username'] == null ? undefined : json['username'],
        'avatarUrl': json['avatar_url'] == null ? undefined : json['avatar_url'],
        'getDisplayName': json['get_display_name'] == null ? undefined : json['get_display_name'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'isSuperuser': json['is_superuser'] == null ? undefined : json['is_superuser'],
        'isStaff': json['is_staff'] == null ? undefined : json['is_staff'],
        'hasUsablePassword': json['has_usable_password'] == null ? undefined : json['has_usable_password'],
        'language': json['language'] == null ? undefined : json['language'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

  export function PatchedCustomUserToJSON(json: any): PatchedCustomUser {
      return PatchedCustomUserToJSONTyped(json, false);
  }

  export function PatchedCustomUserToJSONTyped(value?: Omit<PatchedCustomUser, 'id'|'avatar_url'|'get_display_name'|'has_usable_password'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
        'username': value['username'],
        'is_active': value['isActive'],
        'is_superuser': value['isSuperuser'],
        'is_staff': value['isStaff'],
        'language': value['language'],
        'timezone': value['timezone'],
    };
}

